import { Injectable } from '@angular/core';
import { ApplicationApiClient } from '@nk/api-client-lib';
import { StableCache } from '@nk/caching-lib';
import { AppIconEntity, WithUuid } from '@nk/data-entities-lib';
import { arrayToDict, Dict } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityUpdateTimestampService } from './entity-update-timestamp.service';

@Injectable()
export class AppIconService {
  constructor(
    private _applicationApi: ApplicationApiClient,
    private _entityUpdateTimestampService: EntityUpdateTimestampService,
  ) {}

  public appIconDictCache = new StableCache(
    'app.app_icon',
    this,
    this.fetchAppIconDict,
    this._entityUpdateTimestampService.timestamps$,
  );
  public fetchAppIconDict(): Observable<Dict<WithUuid<AppIconEntity>>> {
    return this._applicationApi
      .get<WithUuid<AppIconEntity>[]>('app-icon')
      .pipe(map((icons) => arrayToDict(icons, (i) => i.uuid)));
  }
}
